// extracted by mini-css-extract-plugin
export default {"container":"style_container__ZqKY3","header":"style_header__7tMMk","content":"style_content__uvhsJ","actions":"style_actions__ddHoU"};